import type { IssueSummary, IssueStatus } from '@chatsdet/types/issues';
import type { BadgeProps } from '@chatsdet/ui';
export const issueSeverityBadgeVariants: Record<IssueSummary['severity'], BadgeProps['variant']> = {
  high: 'destructive',
  medium: 'warning',
  low: 'outline',
  unknown: 'secondary',
};

export const formatSeverityLabel = (severity: IssueSummary['severity']) => severity.toUpperCase();

export const issueStatusBadgeVariants: Record<IssueStatus, BadgeProps['variant']> = {
  open: 'default',
  closed: 'success',
  not_a_bug: 'secondary',
};

export const formatStatusLabel = (status: IssueStatus): string =>
  status.replace(/_/g, ' ').toUpperCase();
